<mat-toolbar class="header-content">
    <div class="header-title">
        <mat-icon>warning</mat-icon>
        {{ 'trackers.duplicate_name_title'|translate }}
    </div>
</mat-toolbar>

<mat-dialog-content>
    <p>{{ messageKey | translate }}</p>

    <ul *ngIf="data.names.length > 1" class="duplicate-name-list">
        <li *ngFor="let name of data.names">{{ name }}</li>
    </ul>

    <div class="choice-actions">
        <lib-button color="none" textColor="muted" text="{{'form.cancel'|translate}}"
            (click)="choose(false)"></lib-button>
        <lib-button color="primary" icon="check" text="{{'form.continue'|translate}}"
            (click)="choose(true)"></lib-button>
    </div>
</mat-dialog-content>
